import hasClockedIn from '@sdk/timeClock/utils/hasClockedIn';
import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';

import timeclockNoteUrl from './timeclockNote.html';

class TimeclockNoteCtrl {
  constructor(Authentication, TimesheetsUtils, focus, $scope) {
    'ngInject';

    Object.assign(this, { Authentication, TimesheetsUtils, focus, $scope });
  }

  $onInit() {
    this.originalAssigneeNotes = this.shift?.assigneeNotes;
    this.showEditOption = false;

    this.timesheetApproved = this.shift?.timesheetStatus === TimesheetStatus.approved;
    this.hasClockedIn = hasClockedIn;
    if (this.shouldBeEditActive) {
      this.setEditNoteMode();
    }
  }

  $onChanges({ confirmationAfterShift }) {
    if (confirmationAfterShift && !confirmationAfterShift.isFirstChange()) {
      if (this.shouldBeEditActive) {
        this.setEditNoteMode();
        this.noteValueHasChanged =
          this.shift.assigneeNotes === '' ? true : this.noteValueHasChanged;
      } else {
        this.setIfWereChanges();
      }

      this.originalAssigneeNotes = this.shift?.assigneeNotes;
    }
  }

  setIfWereChanges() {
    if (this.originalAssigneeNotes === this.shift.assigneeNotes) {
      this.noteValueHasChanged = false;
      return;
    }

    this.noteValueHasChanged = true;
  }

  get shouldBeEditActive() {
    if (this.confirmationAfterShift) {
      if (this.TimesheetsUtils.canEditTimesheet(this.shift) && this.addNoteMode) {
        return true;
      }

      return !this.shift.assigneeNotes || this.addNoteMode;
    }

    if (!this.readOnly && this.shift) {
      return !(this.shift.assigneeNotes && !this.addNoteMode);
    }

    return false;
  }

  mouseOver() {
    if (this.readOnly) {
      return;
    }

    this.showEditOption = true;
  }

  mouseLeave() {
    this.showEditOption = false;
  }

  setEditNoteMode() {
    this.addNoteMode = true;
  }

  async onEnter() {
    if (!this.shift.clockInStatus.clockedIn) {
      return;
    }

    const updatedEvent = await this.onEnterHandler();
    if (updatedEvent) {
      this.originalAssigneeNotes = updatedEvent.assigneeNotes;
      this.addNoteMode = updatedEvent.assigneeNotes === '';
    }
  }
}

export default {
  templateUrl: timeclockNoteUrl,
  controller: TimeclockNoteCtrl,
  controllerAs: 'ctrl',
  bindings: {
    shift: '=',
    readOnly: '<',
    confirmationAfterShift: '<',
    addNoteMode: '=',
    noteValueHasChanged: '=',
    onEnterHandler: '&',
  },
};
